import {
  STOPES_ROUTE_PATH as StopeDetailsPageRoute,
  ROUTE_PARAM_IDENTIFIER as StopePageParamIdentifier
} from 'modules/project/ProjectAreaPage/constants';
import { useDeleteStopeMutation } from 'providers/api';
import { useConfirmation } from 'providers/confirm';
import { ConfirmationOptions } from 'providers/confirm/ConfirmDialog';
import { replace } from 'ramda';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

const confirmDialogOptions = (stopeName: string): ConfirmationOptions => ({
  variant: 'danger',
  description: `Are you sure you want to remove '${stopeName}'?`,
});

const useDeleteStope = () => {
  const navigate = useNavigate();
  const confirm = useConfirmation();
  const deleteMutation = useDeleteStopeMutation();
  const queryClient = useQueryClient();

  const deleteStope = (
    entityId: string,
    nodeId: string,
    stopeId: string,
    stopeName: string,
    onSuccess?: (successNodeId: string) => void,
  ) => {
    confirm(confirmDialogOptions(stopeName))
      .then(() => deleteMutation.mutate(
        { projectId: entityId, stopeId, stopeName, nodeId },
        {
          onSuccess: async () => {
            onSuccess?.(nodeId);
            const stopesListTemplate = replace(/\/\*$/, '', StopeDetailsPageRoute);
            const stopesListUrl = replace(StopePageParamIdentifier, entityId, stopesListTemplate);
            await Promise.all([
              queryClient.invalidateQueries({ queryKey: ['stopes', entityId] }),
              queryClient.invalidateQueries({ queryKey: ['mineOverview', entityId] }),
            ]);
            navigate(stopesListUrl, { replace: true });
          },
        },
      ));
  };

  return deleteStope;
};

export default useDeleteStope;
